export default function permutive() {
  // @TODO this script was a mess and needs re-thinking
  // from scratch.
  return;
}
